import {CSSProperties} from "react";

const dateRangeSelectorStyle: CSSProperties = {
  width: '100%',
  height: '104px',
  marginBottom: '25px',
  position: 'relative',
}

export const styles = {
  DateRangeSelector: dateRangeSelectorStyle,
}